import { businessStore } from 'entities/index';
import { WorkingHoursPicker } from 'features/index';
import { IWeekWorkTime } from 'features/working-hours-picker/interfaces/time-table-input.interface';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import { IUpdateBusinessDto } from 'shared/api/business/interfaces/update-business-info-dto.interface';
import { DEFAULT_TIME_TABLE } from 'shared/consts/schedule';
import { Alert, DefaultButton, FormInput } from 'shared/ui';
import { validateForm } from '../model/validate-form';
import styles from './business-settings.module.scss';

export const BusinessSettingsInfo: React.FC = observer(() => {
  const [name, setName] = useState(
    businessStore.businessHeaderData?.name || ''
  );
  const [address, setAddress] = useState(
    businessStore.businessHeaderData?.address || ''
  );
  const [phone, setPhone] = useState(
    businessStore.businessHeaderData?.contactPhone || ''
  );
  const [siteUrl, setSiteUrl] = useState(
    businessStore.businessHeaderData?.siteUrl || ''
  );
  const [description, setDescription] = useState(
    businessStore.businessHeaderData?.description || ''
  );
  const [weekWorkTime, setWeekWorkTime] = useState<IWeekWorkTime>(
    toJS(businessStore.businessHeaderData?.weekWorkTime) || DEFAULT_TIME_TABLE
  );
  const [validationError, setValidationError] = useState<undefined | string>();
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const businessId = businessStore.businessId;

  useEffect(() => {
    setValidationError(
      validateForm({ name, address, phone, siteUrl, description })
    );
  }, [name, address, phone, siteUrl, description]);

  const handleCloseAlert = useCallback(() => setAlertMessage(null), []);

  const handleSubmit = async () => {
    if (!validationError && businessId) {
      try {
        const data: IUpdateBusinessDto = {
          id: businessId,
          currentTime: new Date(),
          name,
          address,
          contactPhone: phone,
          siteUrl,
          description,
          weekWorkTime,
        };
        await businessStore.updateBusinessHeaderData(data);
        setAlertMessage('Изменения успешно сохранены');
      } catch (error) {
        if (error instanceof Error) {
          setValidationError(error.message);
        }
      }
    }
  };

  return (
    <div className={styles.business_settings}>
      <div className={styles.business_settings__content}>
        <div className={styles.content__inputs}>
          <div className={styles.inputs_block}>
            <div className={styles.inputs__input}>
              <FormInput
                inputValue={name}
                inputTitle="Название бизнеса"
                inputPlaceholder="Название бизнеса"
                onChange={(value) => {
                  setName(value);
                }}
              />
            </div>
            <div className={styles.inputs__input}>
              <FormInput
                inputValue={description}
                inputTitle="Описание"
                inputPlaceholder="Введите описание"
                onChange={(value) => {
                  setDescription(value);
                }}
              />
            </div>
            <div className={styles.inputs__input}>
              <FormInput
                inputValue={address}
                inputTitle="Адрес бизнеса"
                inputPlaceholder="Адрес бизнеса"
                onChange={(value) => {
                  setAddress(value);
                }}
              />
            </div>
            <div className={styles.inputs__input}>
              <FormInput
                inputValue={phone}
                isPhone={true}
                inputTitle="Номер телефона для связи"
                onChange={(value) => {
                  setPhone(value.match(/\d+/g)?.join('') ?? '');
                }}
              />
            </div>
            <div className={styles.inputs__input}>
              <FormInput
                inputType="site"
                inputValue={siteUrl}
                inputTitle="Ссылка на сайт"
                inputPlaceholder="Введите адрес сайта"
                onChange={(value) => {
                  setSiteUrl(value);
                }}
              />
            </div>
          </div>
          <div className={styles.inputs_block}>
            <div className={styles.inputs__input}>
              <WorkingHoursPicker
                inputTitle="График работы"
                onChangeTimeTableHandler={(value) => {
                  setWeekWorkTime({ ...value });
                }}
                inputTimeTable={weekWorkTime}
              />
            </div>
          </div>
        </div>
        <div className={styles.content__buttons}>
          <div className={styles.buttons__error}>{validationError}</div>

          <div className={styles.buttons_button} onClick={handleSubmit}>
            <DefaultButton buttonText="Сохранить изменения" color="white" />
          </div>
        </div>
      </div>
      {alertMessage && (
        <Alert
          type="success"
          message={alertMessage}
          onClose={handleCloseAlert}
        />
      )}
    </div>
  );
});
